import nonEmptyStringValidator from 'foundation/js/inputValidators/nonEmptyStringValidator'

export default [
    {
        name: 'teamName',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'donationGoal',
        value: 0,
        isValid: false,
        validator: (value) => value > 0
    },
    {
        name: 'logo',
        value: null,
        isValid: false,
        validator: () => true
    },
    {
        name: 'description',
        value: '',
        isValid: false,
        validator: (value) => value.length <= 250
    },
    {
        name: 'slogan',
        value: '',
        isValid: false,
        validator: (value) => value.length <= 100
    }
]
